import React from 'react';
import { useRouter as useNextRouter } from 'next/router';

import { createUrlParam } from '@projectaltair/gemini-fetcher';

import { generateUrl, Params } from '../url';

const useRedirect = () => {
  const router = useNextRouter();
  const redirect = React.useCallback(
    ({ name, id, query, url, pushType = 'push' }: Params): void => {
      if (url) {
        if (pushType === 'replace') {
          router.replace(url);
        } else {
          router.push(url);
        }
      } else {
        if (pushType === 'replace') {
          router.replace(generateUrl({ name, id, query }));
        } else {
          router.push(generateUrl({ name, id, query }));
        }
      }
    },
    [router],
  );
  const locationRedirect = React.useCallback((name: string, query?: any) => {
    window.location.href = createUrlParam(name, query);
  }, []);
  return {
    redirect,
    locationRedirect,
  };
};

export default useRedirect;
